// extracted by mini-css-extract-plugin
export default {"divisor":"Transactions_divisor__hmRs9","loadingContainer":"Transactions_loadingContainer__v2g0j","loading":"Transactions_loading__8Xic1"};